import React, { useEffect, useState } from "react";
import useViewport from "components/UseViewport/UseViewport";
import MemberInfo from "containers/AboutUs/Members/MemberInfo/MemberInfo/MemberInfo";
import { SpinLoad } from "components/Spin/SpinLoad";
import { Col, Divider, Row, Space, Typography } from "antd";
import axios from "axios";
import { ActiveMember } from "../../../interfaces/activeMember";
import MemberInfoMobile from "./MemberInfo/MemberInfoMobile/MemberInfoMobile";

const { Title } = Typography;

const Members = () => {
  const [blMembers, setBlMembers] = useState<ActiveMember[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  const { width } = useViewport();
  const breakpoint = 992;

  useEffect(() => {
    axios.get<ActiveMember[]>("/internal/active-members/").then(response => {
      const alphabetic: Array<ActiveMember> = [...response.data].sort((a, b) =>
        // Sort by name
        a.first_name.localeCompare(b.first_name)
      );
      const sorted: Array<ActiveMember> = [];
      response.data.forEach(member => {
        // Leder first, nestleder second
        if (member.duties === "Leder") {
          alphabetic.splice(alphabetic.indexOf(member), 1);
          sorted.unshift(member);
        } else if (member.duties === "Nestleder") {
          alphabetic.splice(alphabetic.indexOf(member), 1);
          sorted.push(member);
        }
      });
      alphabetic.forEach(member => sorted.push(member)); // Add remaining members by alphabet
      setBlMembers(sorted);
      setLoading(false);
    });
  }, []);

  // Display all active group leaders in Bindeleddet
  const displayActiveBlMembersLeaders = blMembers.map(blMember => {
    if (!blMember.show_on_bl_page) return null;
    if (!blMember.duties?.length) return null;

    return (
      <Col key={blMember.id}>
        {width < breakpoint ? (
          <MemberInfoMobile
            BlMemberImage={blMember.profile_picture}
            BlMemberName={blMember.full_name}
            BlMemberRole={blMember.duties}
            BlMemberTelephone={blMember.mobile}
            BlMemberEmail={blMember.bl_email}
          />
        ) : (
          <MemberInfo
            BlMemberImage={blMember.profile_picture}
            BlMemberName={blMember.full_name}
            BlMemberRole={blMember.duties}
            BlMemberTelephone={blMember.mobile}
            BlMemberEmail={blMember.bl_email}
          />
        )}
      </Col>
    );
  });

  // Display all active members without leaderrole in Bindeleddet
  const displayActiveBlMembers = blMembers.map(blMember => {
    if (!blMember.show_on_bl_page) return null;
    if (blMember.duties?.length) return null;

    return (
      <Col key={blMember.id}>
        {width < breakpoint ? (
          <MemberInfoMobile
            BlMemberImage={blMember.profile_picture}
            BlMemberName={blMember.full_name}
            BlMemberRole={blMember.duties}
            BlMemberTelephone={blMember.mobile}
            BlMemberEmail={blMember.bl_email}
          />
        ) : (
          <MemberInfo
            BlMemberImage={blMember.profile_picture}
            BlMemberName={blMember.full_name}
            BlMemberRole={blMember.duties}
            BlMemberTelephone={blMember.mobile}
            BlMemberEmail={blMember.bl_email}
          />
        )}
      </Col>
    );
  });
  return (
    <>
      <Space direction="horizontal" style={{ width: "100%", justifyContent: "center" }}>
        <Title>Medlemmer</Title>
      </Space>
      <Divider />

      <Row>
        <Col span={24}>
          <Row style={width < breakpoint ? { justifyContent: "center" } : { justifyContent: "left" }}>
            <Title level={3}>Våre ledere</Title>
            <br />
            <br />
          </Row>

          <Row gutter={[25, 30]} style={width < breakpoint ? { justifyContent: "center" } : { justifyContent: "left" }}>
            {loading ? <SpinLoad /> : displayActiveBlMembersLeaders}
          </Row>

          <Row>
            <br />
            <br />
          </Row>

          <Row style={width < breakpoint ? { justifyContent: "center" } : { justifyContent: "left" }}>
            <Title level={3}>Våre medlemmer</Title>
            <br />
            <br />
          </Row>

          <Row gutter={[25, 30]} style={width < breakpoint ? { justifyContent: "center" } : { justifyContent: "left" }}>
            {loading ? <SpinLoad /> : displayActiveBlMembers}
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default Members;
